import './App.css';
import { Toaster } from 'react-hot-toast';
import CoachRoutes from './routes/coach/CoachRoutes';
import AdminRoutes from './routes/admin/AdminRoutes';
import FindAJobRoutes from './routes/find-a-job/FindAJobRoutes';
import HireTalentRoutes from './routes/hire-talent/HireTalentRoutes';
import EnterPrisesRoutes from "./routes/enterprises/EnterPrisesRoutes";
import FundingRoutes from './routes/funding/FundingRoutes';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" reverseOrder={false} />
      <CoachRoutes />
      <AdminRoutes />
      <FindAJobRoutes />
      <HireTalentRoutes />
      <EnterPrisesRoutes />
      <FundingRoutes />
    </div>
  );
}

export default App;